import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { formatUptime } from "../Health/model";

// Fold-in fix: fa-plug-circle-check is a Font Awesome Pro-only glyph not
// present in this app's bundled free subset — rendered as an empty
// missing-glyph box. Inline SVG in the same stroke-icon style as the rest
// of the honey Screens page (.claude/pp-screens-prototype.html), scoped to
// this icon only.
const IcConnected = (props) => (
    <svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth={1.8} {...props}>
        <circle cx="12" cy="12" r="9" /><path d="M8 12.5l2.5 2.5L16 9" />
    </svg>
);

const WorkingTimer = ({ time, small = false }) => {
    const { t } = useTranslation();
    const [timeElapsed, setTimeElapsed] = useState("");

    useEffect(() => {
        if (!time) return;

        // Convert timestamp to local time zone
        const firstLoginDate = moment.utc(time).local(); // Convert UTC to Local Time

        const updateElapsedTime = () => {
            const now = moment();
            const duration = moment.duration(now.diff(firstLoginDate));

            // build 396: words in the page language ("37 دقيقة" / "37 minutes", "ساعتان" / "2 hours"), not the hard-coded "2d : 5h : 30m"
            setTimeElapsed(formatUptime(t, Math.floor(duration.asMinutes()), t('devices.group_just_now')));
        };

        // Update immediately and every minute
        updateElapsedTime();
        const interval = setInterval(updateElapsedTime, 60000); // Update every 60s

        return () => clearInterval(interval);
    }, [time, t]);

    if (small) {
        return (
            <div className="bg-label-success px-1 py-0 d-flex align-items-center text-[10px]">
                <IcConnected className="me-1" width={10} height={10} />
                <span className="fw-bold text-[#606A7F]">{timeElapsed}</span>
            </div>
        );
    }

    return (
        <div className="bg-label-success p-2 d-flex align-items-center" >
            <IcConnected className="me-1" width={18} height={18} />
            <div className="d-flex  flex-column ms-1 ">
                <div className="fs-10 text-light text-uppercase fw-bold">{t('devices.group_up_time')}</div>
                <div className="fw-bold text-[#606A7F]">{timeElapsed}</div>
            </div>
        </div>
    );
};

export default WorkingTimer;
